import React,{ useState,useContext,useEffect, useRef } from 'react'
/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { Space,Table} from 'antd';
import { Pagination } from 'antd';
import Button from '@mui/material/Button';
import { ButtonBase } from '@mui/material';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';

import axios from '../apiClient';
import Alert from '../alert';
import { pageContext } from '../../context';

export default function SubAccounts() {
  const {currentPages,changePages} = useContext(pageContext)
  const [page,setPage] = useState(currentPages.subOwnerListPage);
  const [subMasters,setSubMasters] = useState([]);
  const [loading,setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [totalSubMasters, setTotalSubMasters] = useState();
  const mounted = useRef(false)
  const [searchName,setSearchName] = useState('');
  const navigate = useNavigate()
  useEffect(()=>{
    if(mounted.current){
      if(searchName != ''){
        handleSearch(searchName,page)
        return;
      }
      fetchData({})
    }
  },[page])  

  useEffect(()=>{
    if(mounted.current) setPage(1)
  },[searchName])

   useEffect(()=>{
     mounted.current = true
     fetchData({})
   },[])

   // get data from backend when componenet is first mounted
  async function fetchData({action,status,id}) {
    setLoading(true)

    // if action is true -----------------------------------------
    if(action){
      let url;
      let params;
      if(action == 'suspend'){
        params ={'ownerId': id,"is_suspended": status}
        url = `/owner/updateSuspendedStatus`
      }
      let data = await axios.put(url,params)

      if(data.code == 200){
        if(action == 'suspend') data.message = `${status == 'true' ? "Successfully locked the sub owner" : "Successfully unlocked the sub owner"}`
      }
      setErrorMsg({ code: data.code, msg: data.message })
      setOpenAlert(true)
    }
    //-------------------------------------------------------------------------------------

    let data = await axios.get(`/owner/getSubOwnerByOwnerId?current=${page}&pageSize=10`)

    if (data.code != 200) {
        if(data.code == 404){
            setLoading(false)
            setSubMasters([])
            return
        }
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setSubMasters(data.data.owners)
    setTotalSubMasters(data.data.pagination.total)
    setLoading(false)
}
  //--------------------------------------------------

  function formatString(inputString) {
    const words = inputString.split(',');
    const formattedWords = words.map(word => {
      if(word == '*') word = 'All'
      // Remove periods and asterisks
      const cleanedWord = word.replace(/[.*]/g, '');
  
      // Capitalize the first letter
      const capitalizedWord = cleanedWord.charAt(0).toUpperCase() + cleanedWord.slice(1);
  
      return capitalizedWord;
    });
  
    return formattedWords.join(', ');
  }
  const columns = [
    {
      title: 'Username',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Phone No.',
      key: 'phone_number',
      dataIndex: 'phone_number',
    },
    {
      title: 'Access',
      key: 'access_type',
      dataIndex: 'access_type',
      render: (access_type) => {
        if(access_type == "*") return "All";
        return formatString(access_type)
      }
    },
    {
      title: 'Action',
      render: (data) => {
        const {is_suspended,id} = data;
        const editColor = "#4E6E81"
        const negativeColor = "#EA5455"
        const LockColor = `${is_suspended == 'true' ? `${negativeColor}`: `#655DBB`}`

        return (
        <Space size="middle">
         <Button onClick={()=>handleAction({action: "suspend",status: `${is_suspended == `true` ? false : true}`,id})} css={css`color: black;border-color: ${LockColor};:hover{border-color: ${LockColor};}`} color='success' variant="outlined" startIcon={<LockRoundedIcon css={css`color: ${LockColor};`}/>}>
              {is_suspended == 'true' ? `UnLock` : `Lock`}
         </Button>
         <Button onClick={()=>handleAction({action: "edit",data})}  css={css`color: black;border-color: ${editColor};:hover{border-color: ${editColor};};`} color='success' variant="outlined" startIcon={<EditRoundedIcon css={css`color: ${editColor};`}/>}>
            Edit
         </Button>
        </Space>
      )},
    },
    
  ];
  const handleAction = (obj) =>{
    const {action} = obj;
    if(action == "edit"){
      navigate('/master-management/subAccounts/editSubAccounts',{state: obj.data})
      return
    }
    fetchData(obj)
  }
  const handleCloseAlert =()=>{
    setOpenAlert(false)
  }
  const handleSearch = async (name,page) => {
    setLoading(true)
    setSearchName(name)
    let data = await axios.get(`/owner/getSubOwnerByOwnerId?current=${page}&pageSize=10&s=${name}`)
    setLoading(false)
    if (data.code != 200) {
        if(data.code == 404){
          setSubMasters([])
          return
        }
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
        return
    }
    setSubMasters(data.data.owners)
    setTotalSubMasters(data.data.pagination.total)
  }
  const handlePageChange = (page) => {
    setPage(page)
    changePages({subOwnerListPage: page})
  }
  return (
    <div>
    <div>
       <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
       <div css={css`display: flex;justify-content: space-between;`}>
          <input placeholder='Search...' css={css`padding: 0.6rem 0.6rem;border-radius: 0.6rem;border: 1px solid grey;outline: none;&:focus {border-color: #5e35b1;}`} onChange={(e)=>handleSearch(e.currentTarget.value,page)}/>
          <ButtonBase onClick={()=>navigate('/master-management/createSubAccount')} component="div" css={css`background-color: #5e35b1;padding: 0 1rem;border-radius: 0.6rem;color: white;`}><AddIcon css={css`font-size: 1rem;`}/>Add New Sub Account</ButtonBase>
        </div>
      <Table loading={loading} scroll={{ x: 'max-content' }} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={subMasters} />
      <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={totalSubMasters} pageSize={10} showSizeChanger={false} onChange={(page) => handlePageChange(page)} />
    </div>
  </div>
  )
}
